<div class="row">
    <div class="form-group col-md-6 col-lg-6 col-sm-12 col-xs-12 datepicker-custom ">
        <div class="form-inline">
            <div class="form-group">
                <input autocomplete="off" class="form-control " (click)="datePickerId.toggle()" placeholder="gg-mm-aaaa"
                    name="dp" [(ngModel)]="globalData.datePicker.dataSelezionata" ngbDatepicker
                    #datePickerId="ngbDatepicker">

                <a (click)="globalData.aggiornaDatiRiepilogoCompleto(globalData.datePicker.dataSelezionata)"
                    skipLocationChange=true class="btn btn-primary">Scegli
                    una data</a>
            </div>
        </div>
    </div>
</div>